// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { NotaIntegrativaCepDto } from '@ideapa/common-dto';
import { map } from 'rxjs';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class NotaIntegrativaCepApiClient extends BaseCRUDApiClient<NotaIntegrativaCepDto> {
  baseUrl = this.config.apiEndpoint + '/nota-integrativa-cep';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  downloadNotaIntegrativa(body: {
    idNotaIntegrativa: number;
    idTemplate: number | null;
  }) {
    return this.http
      .post(`${this.baseUrl}/download-nota-integrativa`, body, {
        responseType: 'arraybuffer',
      })
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        })
      );
  }
}
